const translations = {
  en: {
    app: require('./app.json'),
    aggregatedAlert: require('./aggregatedAlert.json')
  }
}

export default translations
